import React from 'react';
import { Box, Button, Chip, Stack, Typography } from '@mui/joy';
import { Link } from 'react-router-dom';
import { formatWeekDayLabel, type WeekInstallRow, type WorkspaceOperations } from './workspaceDashboard.model';
import { formatCompletionStatus } from './openJobCards.model';

function CompletionStatus({ row }: { row: WeekInstallRow }) {
  if (!row.jobCardId) {
    return <Typography level="body-sm" sx={{ color: 'neutral.500' }}>No job card</Typography>;
  }
  return (
    <Chip
      size="sm"
      variant="soft"
      color={row.completion?.kind === 'completed' ? 'success' : 'neutral'}
      sx={{ whiteSpace: 'normal', '--Chip-minHeight': 'auto', py: 0.25 }}
    >
      {formatCompletionStatus(row.completion)}
    </Chip>
  );
}

const WorkspaceDashboardWeek: React.FC<{ ops: WorkspaceOperations }> = ({ ops }) => {
  return (
    <Stack gap={1.5}>
      <Box>
        <Typography level="title-lg">Installs this week</Typography>
        <Typography level="body-xs" sx={{ color: 'neutral.500' }}>
          Next 7 days from today. Calendar invite first; job-card override when set.
        </Typography>
      </Box>
      {ops.week.length === 0 ? (
        <Typography level="body-sm" sx={{ color: 'neutral.500' }}>
          No installs dated in the next 7 days.
        </Typography>
      ) : (
        <Box sx={{ overflowX: 'auto' }}>
          <Box
            component="table"
            sx={{
              width: '100%',
              borderCollapse: 'collapse',
              '& th': { textAlign: 'left', fontSize: '0.75rem', color: 'neutral.500', py: 0.75, borderBottom: '1px solid', borderColor: 'divider' },
              '& td': { py: 1, borderBottom: '1px solid', borderColor: 'divider' },
            }}
          >
            <thead>
              <tr>
                <th>Day</th>
                <th>Time</th>
                <th>Workspace</th>
                <th>Customer</th>
                <th>Crew</th>
                <th>Source</th>
                <th>Status</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {ops.week.map((row) => (
                <tr key={`${row.projectId}-${row.jobCardId || 'calendar'}-${row.dayKey}`}>
                  <td>
                    <Typography level="body-sm">{formatWeekDayLabel(row.dayKey)}</Typography>
                    {row.spanNote && (
                      <Typography level="body-xs" sx={{ color: 'neutral.500' }}>{row.spanNote}</Typography>
                    )}
                  </td>
                  <td><Typography level="body-sm">{row.time}</Typography></td>
                  <td>
                    <Typography
                      level="body-sm"
                      fontWeight="lg"
                      component={Link}
                      to={row.href}
                      sx={{ textDecoration: 'none' }}
                    >
                      {row.workspace}
                    </Typography>
                  </td>
                  <td><Typography level="body-sm">{row.customer}</Typography></td>
                  <td><Typography level="body-sm">{row.crew}</Typography></td>
                  <td><Typography level="body-sm">{row.source}</Typography></td>
                  <td><CompletionStatus row={row} /></td>
                  <td>
                    <Button size="sm" variant="plain" component={Link} to={row.href}>
                      Open
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default WorkspaceDashboardWeek;
